export enum InformationType {
    Legal = 'legal',
    Location = 'location',
    Management = 'management'
}
